module.exports = __webpack_public_path__ + "assets/img/home-swiper-1.bfcd3d4b.png";